<template>
    <div id="auth" class="container-fluid">
        <div class="row align-items-center justify-content-center">
            <div class="col-md-6">
                <div class="alert alert-info" v-if="$route.query.continue == 'true'">Please register to continue</div>
                
                <form @submit.prevent="register" class="form">
                    <h1>Create an Account</h1>
                    <p class="mb-4">Fill out the form below to start saving hot springs to your profile.</p>
                    
                    <b-form-group>
                        <b-form-input v-model.trim.lazy="$v.authData.name.$model" :class="{ 'is-invalid': $v.authData.name.$error }" placeholder="First name"></b-form-input>
                        <div class="invalid-feedback" v-if="$v.authData.name.$error">Name must be at least 2 characters</div>
                    </b-form-group>
                    
                    <b-form-group>
                        <b-form-input v-model.trim.lazy="$v.authData.email.$model" :class="{ 'is-invalid': $v.authData.email.$error }" placeholder="Email address"></b-form-input>
                        <div class="invalid-feedback" v-if="$v.authData.email.$error">Please enter a valid email address</div>
                    </b-form-group>
                    
                    <div class="row">
                        <b-form-group class="col-sm">
                            <b-form-input type="password" v-model.trim="$v.authData.password.$model" :class="{ 'is-invalid': $v.authData.password.$error }" placeholder="Choose a password"></b-form-input> 
                            <div class="invalid-feedback" v-if="$v.authData.password.$error">Please enter a stronger password <a v-b-tooltip.hover title="Good passwords are hard to guess. Use uncommon words or inside jokes, non-standard uPPercasing, creative spelllling, and non-obvious numbers and symbols."><fa-icon :icon="['fal', 'info-circle']" /></a></div>
                        </b-form-group>
                        <b-form-group class="col-sm">
                            <b-form-input type="password" v-model.trim="$v.authData.confirm_password.$model" :class="{ 'is-invalid': $v.authData.confirm_password.$error }" placeholder="Re-enter your password"></b-form-input> 
                            <div class="invalid-feedback" v-if="$v.authData.confirm_password.$error">Passwords must match</div>
                        </b-form-group>
                    </div>
                    
                    <div class="alert alert-danger" v-if="status == 'error'">{{ errorMessage }}</div>
                    
                    <SubmitButton title="Create Account" :is-disabled="$v.$invalid || !$v.$anyDirty" :is-saving="isSaving" class="mr-3" /> Already have an account? <better-link :to="{path: '/login', query: $route.query}">Log In</better-link>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import SubmitButton from '@/components/form-controls/SubmitButton'

import { validationMixin } from 'vuelidate'
import required from 'vuelidate/lib/validators/required'
import minLength from 'vuelidate/lib/validators/minLength'
import email from 'vuelidate/lib/validators/email'
import sameAs from 'vuelidate/lib/validators/sameAs'
import goodPassword from '@/vuelidate/goodPassword'

export default {
    name: 'Register',
    mixins: [
        validationMixin,
    ],
    components: {
        SubmitButton,
    },
    head: {
        title() {
            return {
                inner: 'Create Account',
            }
        },
    },
    validations: {
        authData: {
            name: {
                required,
                minLength: minLength(2),
            },
            email: {
                required,
                email,
            },
            password: {
                required,
                goodPassword,
            },
            confirm_password: {
                sameAsPassword: sameAs('password'),
            },
        },
    },
    data() {
        return {
            authData: {
                name: '',
                email: '',
                password: '',
                confirm_password: '',
            },
        }
    },
    computed: {
        ...mapState('account', ['status', 'errorMessage']),
        isSaving() {
            return this.status == 'in progress'
        },
    },
    methods: {
        register() {
            this.$store.dispatch('account/register', this.authData)
        },
    },
    created() {
        this.unsubscribe = this.$store.subscribe(mutation => {
            if (mutation.type === 'account/setCurrentUserProfile') {
                this.isSaving = false
            }
        });
    },
    activated() {
        this.$emit('updateHead')
    },
    beforeDestroy() {
        this.unsubscribe()
    },
};
</script>